/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIProperty
 */
export interface APIProperty {
    /**
     * 
     * @type {string}
     * @memberof APIProperty
     */
    readonly self: string;
    /**
     * 
     * @type {Date}
     * @memberof APIProperty
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIProperty
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIProperty
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIProperty
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof APIProperty
     */
    type: string;
}

/**
 * Check if a given object implements the APIProperty interface.
 */
export function instanceOfAPIProperty(value: object): value is APIProperty {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function APIPropertyFromJSON(json: any): APIProperty {
    return APIPropertyFromJSONTyped(json, false);
}

export function APIPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIProperty {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
        'value': json['value'],
        'type': json['type'],
    };
}

export function APIPropertyToJSON(value?: Omit<APIProperty, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
        'type': value['type'],
    };
}

